var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgException(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exception_",
    "data-name": "exception ",
    transform: "translate(-354 -575)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(354 575)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(-115.455 21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M135.644,98.825A1.725,1.725,0,0,0,134.122,98a1.775,1.775,0,0,0-1.522.826L116.339,124.13a1.8,1.8,0,0,0,1.522,2.783h32.566a1.813,1.813,0,0,0,1.522-2.783Zm15.174,26.523a.477.477,0,0,1-.435.261H117.861a.478.478,0,0,1-.435-.261.539.539,0,0,1,0-.522l16.3-25.305a.434.434,0,0,1,.435-.217.587.587,0,0,1,.435.217l16.261,25.305a.5.5,0,0,1-.044.521Z",
    transform: "translate(370.41 477.001)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M336.788,252.687l.435-9.087h-1.782l.435,9.087Z",
    transform: "translate(168.048 342.705)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M334.243,378.56q-1.044,0-1.044,1.174a1.062,1.062,0,0,0,.3.87,1.023,1.023,0,0,0,.739.261.985.985,0,0,0,.783-.3,1.105,1.105,0,0,0,.261-.87,1.3,1.3,0,0,0-.261-.87,1.134,1.134,0,0,0-.783-.261Z",
    transform: "translate(170.115 218.223)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgException);
export default __webpack_public_path__ + "static/media/Exception.aff7271c5e066ea63ab98d6b67a4c5d4.svg";
export { ForwardRef as ReactComponent };